import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColdwaveComponent } from './coldwave.component';
import { SharedModule } from '../../shared/shared.module';
import { DataService } from '../../shared/services/data.service';
import { MapService } from 'src/app/utils/map.service';



@NgModule({
  declarations: [ColdwaveComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [ColdwaveComponent],
  providers: [DataService, MapService]
})
export class ColdwaveModule { }
